import React, { CSSProperties, FC } from 'react'

interface UITabBarProps {
  titles: string[]
  styleText?: CSSProperties | undefined
  activeTab: string
  onPressTab: (item: string) => void
  activeTabText?: string
  containerStyle?: string
}

const UITabBar: FC<UITabBarProps> = ({
  titles,
  styleText,
  activeTab,
  onPressTab,
  activeTabText,
  containerStyle,
}) => {
  return (
    <div
      className={`flex flex-row w-full h-12 bg-transparent gap-3  border-b-[1px] border-b-gray2 cursor-pointer ${containerStyle}`}
    >
      {titles?.map((item, index) => (
        <div
          key={index}
          className={`flex justify-center w-fit items-center ${
            activeTab === item
              ? 'bg-transparent border-b-2 border-b-bluishGreen'
              : ''
          }`}
          onClick={() => onPressTab(item)}
        >
          <span
            className={`text-text1 text-sm font-semibold px-3 ${
              activeTab === item ? activeTabText : ''
            }`}
            style={styleText}
          >
            {item}
          </span>
        </div>
      ))}
    </div>
  )
}

export default UITabBar
